import { OrbType } from "../..";
export class ComboBombWrapped {
    constructor(board, p1, p2, prng) {
        this.eliminatedOrbs = [];
        this.mutatedOrbs = [];
        const orb1 = board[p1.c][p1.r];
        const orb2 = board[p2.c][p2.r];
        let color;
        let pBomb;
        if (orb1.type === OrbType.BOMB) {
            color = orb2.color;
            pBomb = p1;
            this.eliminatedOrbs.push({
                p: p1,
                type: OrbType.BOMB,
                n: 40,
                triggeringOrbColor: null,
                collapsing: false,
                collapsingPosition: null,
                isComboWrappedWrappedOrb: false,
                pBomb: null
            });
        }
        else {
            color = orb1.color;
            pBomb = p2;
            this.eliminatedOrbs.push({
                p: p2,
                type: OrbType.BOMB,
                n: 40,
                triggeringOrbColor: null,
                collapsing: false,
                collapsingPosition: null,
                isComboWrappedWrappedOrb: false,
                pBomb: null
            });
        }
        const cols = board.length;
        const rows = board[0].length;
        for (let c = 0; c < cols; c++) {
            for (let r = 0; r < rows; r++) {
                const orb = board[c][r];
                if (orb.color === color && (orb.type === OrbType.NORMAL || orb.type === OrbType.WRAPPED)) {
                    const n = 5 + Math.floor(5 * prng.getRandom());
                    if (orb.type === OrbType.NORMAL) {
                        orb.type = OrbType.WRAPPED;
                        orb.mutated = true;
                        this.mutatedOrbs.push({
                            p: { c: c, r: r },
                            type: OrbType.WRAPPED,
                            n: n,
                            pBomb: pBomb
                        });
                    }
                    this.eliminatedOrbs.push({
                        p: { c: c, r: r },
                        type: OrbType.WRAPPED,
                        n: n + 4,
                        triggeringOrbColor: color,
                        collapsing: false,
                        collapsingPosition: null,
                        isComboWrappedWrappedOrb: false,
                        pBomb: pBomb
                    });
                }
            }
        }
    }
    getEliminatedOrbs() {
        return this.eliminatedOrbs;
    }
    getMutatedOrbs() {
        return this.mutatedOrbs;
    }
}
//# sourceMappingURL=data:application/json;base64,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